<template>
  <div class="toggle-switch">
    <span class="label">{{ $t('video_lecture.auto_play') }}</span>
    <label class="switch" :class="{ 'checked': value }">
      <input type="checkbox" class="switch-input" v-model="value" @change="$emit('change', $event.target.checked)" >
      <div class="switch-track"></div>
      <div class="switch-thumb"></div>
      <div class="switch-focus-ring"></div>
    </label>
  </div>
</template>

<script>
  import { isEmpty } from 'lodash';

  export default {
    name: 'toggle-switch',

    data() {
      return {
        value: JSON.parse(this.$localStorage.get('isVideoAutoState')),
      };
    },

    beforeMount() {
      if (isEmpty(this.$localStorage.get('isVideoAutoState'))) {
        return this.$localStorage.set('isVideoAutoState', true);
      }

      return true;
    },
  };
</script>

<style lang="scss" scoped>
  .toggle-switch {

    .label {
      font-size: 14px;
      margin-right: 8px;
      color: rgba(0, 0, 0, 0.38);
    }

    .switch {
      position: relative;
      &.checked {
        .switch-track {
          background-color: rgba(0,200,150,0.5);
        }
        .switch-thumb {
          left: 14px;
          background-color: #00C896
        }
        .switch-focus-ring {
          left: 3px;
          background-color: rgba(0,200,150,0.12);
        }
      }
    }

    .switch-track {
      position: absolute;
      top: 3px;
      height: 14px;
      width: 34px;
      background-color: rgba(0,0,0,0.26);
      border-radius: 8px;
      transition: background-color 0.1s linear;
    }

    .switch-thumb {
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #fafafa;
      box-shadow: 0 1px 3px rgba(0,0,0,0.4);
      transition: all 0.2s ease;
    }

    .switch-focus-ring {
      position: absolute;
      top: -11px;
      left: -11px;
      z-index: -1;
      border-radius: 50%;
      width: 42px;
      height: 42px;
      background-color: rgba(0,0,0,0.1);
      transform: scale(0);
      opacity: 0;
      transition: all 0.2s ease;
    }

    .switch-input {
      opacity: 0;

      &:focus {
        & ~ .switch-focus-ring {
          transform: scale(1);
          opacity: 1;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// ToggleSwitch.vue?062b73c0